/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, March 2022
 */
/* flow-disable */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import PaperTile from '../../../components/PaperTile/PaperTile';
import PaperHeader from '../../../components/PaperHeader/PaperHeader';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../../../components/utils/utils';
import { getDistrictForUser, replaceMultipleSpaces } from '../../../lib/utils';
import { fetchDistrictServices } from '../../../actions/district';
import { adminEndpoint, adminRole } from '../../../config';
import { DecisionContainer } from '../../../containers';
import v from '../../eservices/validators';
import ModalAlert from '../../eservices/ModalAlert';
import styles from './DistrictDeclarations.css';
import { PanelStyle } from '../../../constants';

const {
  leftCol,
  labelCol,
  inputCol,
  inputStyle,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
} = PanelStyle;


const btnStyle = {
  width: '100%',
};

const btnStyle2 = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const districtDict = {
  createdAt: {
    label: 'Data utworzenia deklaracji',
    editable: true,
  },
  personName: {
    label: 'Osoba do kontaktu - imię i nazwisko',
    editable: true,
  },
  personEmail: {
    label: 'Osoba do kontaktu - email',
    editable: true,
  },
  personPhone: {
    label: 'Osoba do kontaktu - telefon',
    editable: true,
  },
  descriptionLink: {
    label: 'Link do opisu dostępności architektonicznej*',
    editable: true,
  },
  translatorLink: {
    label: 'Link do opisu dostępności tłumacza języka migowego**',
    editable: true,
  },
  translatorDescription: {
    label: 'Opis dostępności tłumacza języka migowego***',
    editable: true,
    type: 'textarea',
  },
};

class DistrictDeclarations extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    districts: PropTypes.object,
  };

  state = {
    selected_district: null,
    filter_text: '',
    colors: 'normal',
    sourceStyle: layoutColorStyle,
    style: {},
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    showModal: false,
    districtData: {
      createdAt: null,
      personName: null,
      personEmail: null,
      personPhone: null,
      descriptionLink: null,
      translatorLink: null,
      translatorDescription: null,
    },
    architecturalAvailability: [
      {
        description: '',
      },
    ],
    defaultDistrictData: {
      createdAt: null,
      personName: null,
      personEmail: null,
      personPhone: null,
      descriptionLink: null,
      translatorLink: null,
      translatorDescription: null,
    },
    defaultArchitecturalAvailability: [
      {
        description: null,
      },
    ],
  };

  validators = {
    createdAt: [v.NotNull, v.CheckDate],
    personName: [v.NotNull],
    personEmail: [v.NotNull, v.CheckEmail],
    personPhone: [v.NotNull],
    description: [v.NotNull],
  };

  componentDidMount = () => {
    this.fetchDistrict();
    const colors = getThemeFromLocalStorage();
    let sourceStyle = layoutColorStyle;
    let style = {
      color: sourceStyle[colors].color,
      display: 'block',
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
        display: 'block',
      };
    }
    this.setState({ colors, sourceStyle, style });
  }

  async fetchDistrict() {
    if (this.props.isDistrictAdmin) {
      const selectedDistrict = await getDistrictForUser(this.props.user.ID);
      this.setState({ selected_district: selectedDistrict }, () => this.fetchDistrictData());
    } else {
      this.setState({ selected_district: null });
    }
  }

  async fetchDistrictData() {
    const url = `${process.env.API_URL}/eservices/declaration_of_availability/${this.state.selected_district}/`;
    fetch(url, {
      method: 'GET',
    }).then(r => r.json())
      .then(resp => {
        const districtData = this.state.districtData;
        districtData.createdAt = resp.createdAt;
        districtData.personName = resp.person_name;
        districtData.personEmail = resp.person_email;
        districtData.personPhone = resp.person_phone_number;
        districtData.descriptionLink = resp.description_link;
        districtData.translatorLink = resp.translator_link;

        const architecturalAvailability = []
        let translatorDescription = false;
        for (const desc of resp.desc_list) {
          if (desc.is_translator_description) {
            translatorDescription = true;
            districtData.translatorDescription = desc.description;
          } else {
            architecturalAvailability.push({
              description: desc.description,
            });
          }
        }

        if (! translatorDescription) {
          districtData.translatorDescription = '';
        }

        this.setState({ districtData, architecturalAvailability, defaultDistrictData: districtData, defaultArchitecturalAvailability: architecturalAvailability });
      });

  }

  cancelChanges = () => {
    this.setState({
      districtData: this.state.defaultDistrictData,
      architecturalAvailability: this.state.defaultArchitecturalAvailability,
    });
  }

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ["districtData"];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  districtFilterChange = (e) => {
    // zamiana kilku spacji na jedną
    const value = replaceMultipleSpaces(e.target.value);
    this.setState({ filter_text: value });
  };

  onClick = (item) => {
    const prefix = this.props.districts[item].prefix;
    this.setState({ selected_district: prefix }, () => this.fetchDistrictData());
  };

  addPosition = () => {
    this.setState({
      architecturalAvailability: [...this.state.architecturalAvailability, {
        description: '',
      }],
    }, () => this.validatePositions());
  }

  removePosition = (i, state) => {
    const list = [...this.state[state]];

    if (i > -1) {
      list.splice(i, 1);
    }

    this.setState({
      [state]: list,
    });
  }

  onChangePosition = (e, state, elem, index) => {
    const arr = this.state[state];
    arr[index][elem] = e.target.value;

    this.setState({
      [state]: arr,
    }, () => this.validatePositions(state, elem, index),
    );
  }

  validatePositions = (group = null, field = null, index = null) => {
    let newState = null;
    if (field) {
      const checks = this.validatePositionField(group, field, index);
      newState = {
          ...this.state.errors,
          [`${field}${index}`]: checks,
      };
    } else {
      let errors = {};
      const grupy = ['architecturalAvailability'];
      for (const g of grupy) {
        const err = this.validateListGroups(g);
        errors = { ...errors, ...err };
      }
      newState = { ...this.state.errors, ...errors };
    }

    if (newState) {
      this.setState({ errors: newState });
    }
  };

  validatePositionField = (group, field, index) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][index][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateListGroups = (group) => {
    const errors = {};
    let idx = 0;
    if (this.state[group]) {
      for (const obj of this.state[group]) {
        for (const i in Object.keys(obj)) {
          const field = Object.keys(obj)[i];
          const checks = this.validatePositionField(group, field, idx);
          errors[`${field}${idx}`] = checks;
        }
        idx += 1;
      }
    }
    return errors;
  };

  getInputWithError = (group, field, idx, value, placeholder) => (
    <div style={{ textAlign: 'justify' }}>
      <input
        type="text"
        className="form-control"
        name={field}
        style={{
          width: '100%',
          borderColor:
            Object.keys(this.state.errors).indexOf(`${field}${idx}`) > -1 &&
              this.state.errors[`${field}${idx}`] !== null &&
              this.state.errors[`${field}${idx}`].length > 0
              ? 'red'
              : '#ccc',
        }}
        value={value}
        placeholder={placeholder}
        onChange={(e) => this.onChangePosition(e, group, field, idx)}
      />
      {/* RENDER ERROS IN SPAN */}
      {Object.keys(this.state.errors).indexOf(`${field}${idx}`) > -1 &&
        this.state.errors[`${field}${idx}`] !== null &&
        this.state.errors[`${field}${idx}`].length > 0
        ? this.state.errors[`${field}${idx}`].map((val, index) => (
          <span key={index} style={errorSpanStyle}>
            {val}
          </span>
        ))
        : null}
    </div>
  )

  showModalAlert = () => {
    this.setState({
      showModal: !this.state.showModal,
    });
  }

  onHide = () => this.setState({ showError: false });

  // modal z potwierdzeniem lub odrzuceniem zmian
  confirmModal = () => {
    return (
      <div className={styles.declarationModal}>
        <div className={styles.declarationModal__container} style={this.state.style}>
          <div className={styles.declarationModal__header}>Czy na pewno chcesz zapisać zmiany?</div>
          <div className={styles.modalButtons}>
            <button onClick={this.showModalAlert} className="btn btn-warning">Anuluj</button>
            <button onClick={this.sendNewCardData} className={`btn btn-success ${styles.modalButtons__right}`}>Zapisz</button>
          </div>
        </div>
      </div>

    );
  }

  sendNewCardData = () => {
    const data = JSON.stringify(
      {
        districtData: this.state.districtData,
        architecturalAvailability: this.state.architecturalAvailability,
      }
    );
    const successMessage = 'Zmiany zostały zapisane. Wymagane jest odświeżenie strony.';
    const failureMessage = 'Wystąpił błąd przy zapisie zmian.';
    fetch(`${process.env.API_URL}/eservices/district_declaration/save/${this.state.selected_district}/`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: data,
      },
    ).then((response) => {
      if (response.status === 200) {
        this.setState({
          errorText: successMessage,
          errorTitle: 'Zmiany zapisane.',
          showError: true,
        });
        window.location.reload();
      } else {
        this.setState({
          errorText: failureMessage,
          errorTitle: 'Błąd przy zapisywaniu zmian.',
          showError: true,
        });
      }
    });
  }

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  async postValidation () {
    await this.validatePositions();
    const hasFieldErrors = this.haseErrors();

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }

    if (this.state.architecturalAvailability.length === 0 && !this.state.districtData.descriptionLink) {
      this.setState({
        errorText: 'Brak opisu dostępności architektonicznej. Wprowadź link lub opis.',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
      });
      return;
    }

    if (this.state.architecturalAvailability.length > 0 && this.state.districtData.descriptionLink) {
      this.setState({
        errorText: 'Wprowadzono opis dostępności architektonicznej oraz link do opisu. Wprowadź tylko link lub opis.',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
      });
      return;
    }

    if (!this.state.districtData.translatorLink && !this.state.districtData.translatorDescription) {
      this.setState({
        errorText: 'Brak opisu dostępności tłumacza języka migowego. Wprowadź link lub opis.',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
      });
      return;
    }

    if (this.state.districtData.translatorLink && this.state.districtData.translatorDescription) {
      this.setState({
        errorText: 'Wprowadzono opis dostępności tłumacza języka migowego oraz link do opisu. Wprowadź tylko link lub opis.',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
      });
      return;
    }

    if (!hasFieldErrors) {
      this.showModalAlert();
    }
  };

  render() {
    return (
      <div style={{ paddingTop: '20px' }}>
        {!this.props.isDistrictAdmin ?
          <div className={'well well-sm'} style={{ background: this.state.style.backgroundColor }}>
            <h4 style={{ textAlign: 'center' }}>
              <b>Gminy:</b>
            </h4>
            <input
              type="text"
              className="form-control"
              style={{ width: '100%', position: 'relative', margin: '25px 0px 15px 0px' }}
              value={this.state.filter_text}
              placeholder="Wyszukaj urząd..."
              onChange={(e) => this.districtFilterChange(e)}
            />
            <ul className={'nav flex-column'} style={{ height: '400px', overflowY: 'scroll' }}>
              {this.props.districts && Object.keys(this.props.districts).sort()
                .filter(item => this.props.districts[item].name.toLowerCase().includes(this.state.filter_text.toLowerCase()))
                .map(item => (

                  <li className={'nav-item'} key={item}>
                    <button
                      type="button"
                      className={'btn btn-primary'}
                      style={btnStyle}
                      onClick={() => this.onClick(item)}
                    >
                      {this.props.districts[item].name}
                    </button>
                  </li>
                ))}
            </ul>
          </div> : null}
        {this.state.selected_district ?
          <h4
            style={{ textAlign: 'center' }}
          >
            <b>{this.props.districts[this.state.selected_district].name}</b>
          </h4> : null}
        <PaperHeader title="Deklaracja dostępności" text="" />

        <DecisionContainer
          title={'Deklaracja dostępności'}
          data={this.state.districtData}
          errors={this.state.errors}
          formDict={districtDict}
          onChange={e => this.onChange(e, 'districtData')}
          >

          <div className="row" style={{ marginTop: '40px' }}>
            <div className="col-sm-8">
              <b>Opis dostępności architektonicznej****</b>
            </div>
            <div className="col-sm-4">
              <button
                type="submit-lg"
                className={'btn btn-primary'}
                style={{ float: 'right', ...btnStyle }}
                onClick={() => this.addPosition()}
              >
                Dodaj pozycję do opisu
            </button>
            </div>
          </div>

          <table className="table">
            <thead>
              <tr>
                <th scope="col">LP</th>
                <th scope="col">Opis</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {this.state.architecturalAvailability.map((v, i) => {
                return (
                  <tr key={i}>
                    <td><p>{i + 1}</p></td>
                    <td style={{ width: '100%' }}>
                      {this.getInputWithError('architecturalAvailability', 'description', i, v.description, 'Opis...')}
                    </td>
                    <td>
                      <button
                        type="submit-lg"
                        className={'btn btn-danger'}
                        style={{ btnStyle2 }}
                        onClick={() => this.removePosition(i, 'architecturalAvailability')}
                      >
                        Usuń
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
          <div>
            <p><b>*</b> obowiązkowe w przypadku braku podania opisu dostępności architektonicznej,</p>
            <p><b>**</b> obowiązkowe w przypadku braku podania opisu dostępności tłumacza języka migowego,</p>
            <p><b>***</b> obowiązkowe w przypadku braku podania linku do opisu dostępności tłumacza języka migowego,</p>
            <p><b>****</b> obowiązkowe w przypadku braku podania linku do opisu dostępności architektonicznej,</p>
          </div>
        </ DecisionContainer>

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle2 }}
              onClick={() => this.startService()}
              disabled={!this.state.selected_district}
            >
              Zapisz zmiany
            </button>
            <button
              type="submit-lg"
              className="btn btn-warning"
              style={{ float: 'right', marginRight: '15px', ...btnStyle2}}
              onClick={() => this.cancelChanges()}
            >
              Anuluj zmiany
            </button>
          </div>
        </div>
        {this.state.showModal ? this.confirmModal() : null}
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
      </div>
    );
  }
}

const mapState = (state) => ({
  districts: state.district.districts,
  eservices: state.district.eservices,
});

const mapDispatch = {
  fetchDistrictServices,
};

export default withStyles(styles)(connect(mapState, mapDispatch)(DistrictDeclarations));



// WEBPACK FOOTER //
// src/routes/admin/district_declarations/DistrictDeclarations.js